const Input = ({
  type = "text",
  name,
  placeholder,
  value,
  onChange,
  className = ""
}) => {
  return (
    <input
      type={type}
      name={name}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      // onKeyDown={onKeyDown}
      className={`form-control rounded-pill py-2 ${className}`}
    />
  );
};

export default Input;
